import React, { useEffect, useState } from "react";
import "./JewelleryGallery.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { URL } from "../../Redux/common/url";


// const images = [
//   "https://media.istockphoto.com/id/1277517088/photo/fancy-designer-antique-golden-bracelets-for-woman-fashion.jpg?s=612x612&w=0&k=20&c=n49O0S5rIgzxJX5bU1YjwRHfou0DYPcmsv-N5JAAM14=",
//   "https://static.vecteezy.com/system/resources/thumbnails/055/148/237/small/brazilian-gold-necklace-classic-patterns-showcasing-brazils-artistic-and-landbased-traditions-photo.jpg",
//   "https://s7ap1.scene7.com/is/image/noveljewelsprod/BridalPolki?dpr=on&ts=1737099298021",
//   "https://cdn.shopify.com/s/files/1/0507/9865/7726/files/gems-1_2048x2048.jpg?v=1682061576",
//   "https://cdn.prod.website-files.com/62428c67e286b9c91b3899d0/626e554e0d49998d81c93210_temple-jewellery-bg.webp",
//   "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcSQ-Glus9MIGw7WdMzEuaZIXOXIETxIQHimo4sCFpbyB-an2sA79yuwEdDpq92KSMOyzrktzAsu35joFTKulc9F2U14D7au4YlIKSk8ys1Zm62fh7wZhuxCWrd8lC6b6PpWVJT1KLY&usqp=CAc",
//    "https://media.istockphoto.com/id/1277517088/photo/fancy-designer-antique-golden-bracelets-for-woman-fashion.jpg?s=612x612&w=0&k=20&c=n49O0S5rIgzxJX5bU1YjwRHfou0DYPcmsv-N5JAAM14=",
//   "https://static.vecteezy.com/system/resources/thumbnails/055/148/237/small/brazilian-gold-necklace-classic-patterns-showcasing-brazils-artistic-and-landbased-traditions-photo.jpg",
//   "https://s7ap1.scene7.com/is/image/noveljewelspod/BridalPolki?dpr=on&ts=1737099298021",
//   "https://cdn.shopify.com/s/files/1/0507/9865/7726/files/gems-1_2048x2048.jpg?v=1682061576",
//   "https://cdn.prod.website-files.com/62428c67e286b9c91b3899d0/626e554e0d49998d81c93210_temple-jewellery-bg.webp",
//   "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcSQ-Glus9MIGw7WdMzEuaZIXOXIETxIQHimo4sCFpbyB-an2sA79yuwEdDpq92KSMOyzrktzAsu35joFTKulc9F2U14D7au4YlIKSk8ys1Zm62fh7wZhuxCWrd8lC6b6PpWVJT1KLY&usqp=CAc",
// ];

function JewelleryGallery() {
    const [productLists, setProductListt] = useState([]);
    
        useEffect(() => {
          fetchProductList();
        }, []);
      

        const fetchProductList = async () => {
          try {
            const response = await fetch(
              `${URL.API_BASE_URL}/publicApi/successListPublic`
            );
            if (response.ok) {
              const data = await response.json();
              setProductListt(data?.successes); // Store the sliders in state
            }
            const data = await response.json();
            console.log(data);
          } catch (error) {
            console.error("Fetch error:", error);
          }
        };
  return (
    <section className="jewellery-gallery py-5">
      <div className="container text-center position-relative">
        <h2 className="gallery-title">Our Jewellery Collection</h2>

        <div className="flowers">
          <span className="flower">🌸</span>
          <span className="flower">🌺</span>
          <span className="flower">🌷</span>
          <span className="flower">🌸</span>
          <span className="flower">🌺</span>
        </div>

        <div className="gallery-masonry">
         {productLists && productLists.length > 0 ? (
            productLists.map((item, index) => ( 
            <div className="masonry-item" key={index}>
              <img
                src={URL?.API_BASE_URL + item?.feature_image}
                  alt={item.feature_image}
           
              />
              {/* <img src={img} alt="Jewellery" /> */}
            </div>
                                                        
       ))
            ) : (
            <p>Loading...</p>
            )}
        </div>
      </div>
    </section>
  );
}

export default JewelleryGallery;
